import { proxy } from "valtio";

interface MyTodosStore {
  actionsCount: number;
}

export const myTodosStore = proxy<MyTodosStore>({
  actionsCount: 0,
});
